module.exports = __webpack_public_path__ + "media/application/images/svgs/check-square-db9a95cf37f247b7e8d5cbfe0aed18bb.svg";